import { Box } from "arkh";
import React, { PropsWithChildren, useMemo } from "react";

import { useDeviceOrientation } from "../../../common/Utils/useDeviceOrientation";
import { useSizeClass } from "../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";
import { PLUCategoryItemHeight } from "../PLULayout";

export const PLUCategoryItemSpacer = React.memo(InnerPLUCategoryItemSpacer);

function InnerPLUCategoryItemSpacer(props: PropsWithChildren<object>) {
  const { landscape } = useDeviceOrientation();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;

  const width = useMemo(
    () => (isCompact ? "25%" : landscape ? "16.6%" : "20%"),
    [isCompact, landscape]
  );
  return (
    <Box
      style={{
        width,
        height: PLUCategoryItemHeight,
      }}
      spaceVertical="xxsmall"
      spaceHorizontal="xxsmall"
    >
      {props.children}
    </Box>
  );
}
